<template>
	<form-dropdown
		v-if="questionTypes"
		:items="questionTypesAvailable"
		:selected="selected"
		label="Misc.QuestionType"
		name="question-type"
		input-updated-event-name="question-type-input-updated-event"
		rules="required"
		component-class="form-inline-box"
	></form-dropdown>
</template>

<script>
import AccountInfo from '@/mixins/AccountInfo'
import FormDropdown from '@/components/atoms/FormDropdown'

export default {
	name: 'QuestionTypeSelector',
	components: {
		FormDropdown,
	},
	mixins: [AccountInfo],
	props: {
		selected: {
			type: [String, Number],
			default: '',
		},
	},
	data() {
		return {
			questionTypes: null,
		}
	},
	computed: {
		questionTypesAvailable() {
			const accountLogged = this.isLoggedIn
			// Filter question types
			return this.questionTypes.filter(function (type) {
				// Return all values for logged accounts, otherwise only not restricted ones
				return (!accountLogged && type.restricted !== true) || accountLogged
			})
		},
	},
	created() {
		if (sessionStorage.getItem('ius_question_types')) {
			// If available, use session storage question types
			this.questionTypes = JSON.parse(sessionStorage.getItem('ius_question_types'))
		} else {
			// Retrieve question types from API and store in session storage
			this.loadData()
		}
	},
	methods: {
		loadData() {
			// Get data
			axios
				.get('/questions/types', {
					params: this.loadAllParams,
				})
				.then((response) => {
					this.questionTypes = response.data.info
					sessionStorage.setItem('ius_question_types', JSON.stringify(this.questionTypes))
				})
				.catch((error) => {
					console.log(error)
				})
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/utils/commons/QuestionTypeSelector.vue